import React from 'react';
import theme from './PriceDisplay.module.scss';
import { PriceCalculationResult } from '@/types';
import { Trans } from '@lingui/react/macro';
import FeeInfoIcon from '../FeeInfoIcon';
import { ProjectCurrencyDisplay } from '@/seller/components/currency';
import { classnames } from '@/utils/html';

interface PriceInfo {
    basePrice: number | null;
    finalPrice: number | null;
}

interface PriceDisplayProps {
    value: PriceCalculationResult | PriceInfo | null | undefined;
    redacted?: boolean;
    inline?: boolean;
    hideInfoIcon?: boolean;
    className?: string;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({ value, redacted, inline = false, hideInfoIcon = false, className }) => {
    if (redacted) {
        return <Trans>Redacted</Trans>;
    }

    if (!value) {
        return <Trans>N/A</Trans>;
    }
    return (
        <div className={classnames(theme.price, { [theme.inline]: inline }, className)}>
            <span>
                {!hideInfoIcon && <FeeInfoIcon />}

                <ProjectCurrencyDisplay value={value.finalPrice || 0} />
            </span>
            <small>
                (<ProjectCurrencyDisplay value={value.basePrice || 0} />)
            </small>
        </div>
    );
};

export default React.memo(PriceDisplay);
